module.exports = __webpack_public_path__ + "static/media/2.71e78532.svg";